import { styled } from '@mui/material/styles';
import { Box, Drawer } from '@mui/material';

export const AdminLayoutContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    minHeight: '100vh',
}));

export const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
}));

export const StyledDrawer = styled(Drawer)(
    ({ theme, open, drawerwidth = 240 }) => ({
        width: drawerwidth,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
            width: drawerwidth,
            boxSizing: 'border-box',
            backgroundColor: theme.palette.primary.main,
            borderRight: `1px solid ${theme.palette.divider}`,
        },
    })
);

export const MainContent = styled(Box)(
    ({ theme, open, drawerwidth = 240 }) => ({
        flexGrow: 1,
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        marginLeft: 0,
        width: '100%',
        ...(open && {
            transition: theme.transitions.create('margin', {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen,
            }),
            width: `calc(100% - ${drawerwidth}px)`,
        }),
        [theme.breakpoints.down('md')]: {
            width: '100%',
        },
    })
);
